// extracted by mini-css-extract-plugin
export default {"popover":"Tooltip_popover__QVH2r","btn":"Tooltip_btn__L29ZL","panel":"Tooltip_panel__+6uSC"};